import React, { useState, useEffect } from 'react';
import { Box, Radio, Typography } from '@mui/material';
import { pengPalOptions } from '../../../shared/shared.constants';
import {
  SelectedIcon,
  UnselectedIcon
} from '../../../shared/components/customRadio';

export default function PalSelector({
  setPalScreenMinValue,
  setPalScreenMaxValue
}: {
  setPalScreenMinValue: (minVal: number) => void;
  setPalScreenMaxValue: (maxVal: number) => void;
}) {
  const [selectedPalId, setSelectedPalId] = useState('');
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(0);

  const handleSelect = (option) => {
    setSelectedPalId(option.id);
    setMinValue(option.min);
    setMaxValue(option.max);
  };

  useEffect(() => {
    setPalScreenMinValue(minValue);
    setPalScreenMaxValue(maxValue);
  }, [minValue, maxValue]);

  return (
    <Box sx={{ maxWidth: 400, p: 0 }}>
      {pengPalOptions.map((option) => {
        const isSelected = selectedPalId === option.id;
        const hasRange = option.min !== option.max; // e.g. 1.10 - 1.20
        const displayedValue = hasRange
          ? `${option.min.toFixed(2)} - ${option.max.toFixed(2)}`
          : `${option.min}`;

        return (
          <Box
            key={option.id}
            onClick={() => handleSelect(option)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 1,
              cursor: 'pointer',
              // Optional hover styling:
              '&:hover': {
                backgroundColor: '#f9f9f9'
              }
            }}
          >
            {/* Radio Button */}
            <Radio
              checked={isSelected}
              onChange={() => handleSelect(option)} // for accessibility
              icon={<UnselectedIcon />}
              checkedIcon={<SelectedIcon />}
            />

            {/* Text portion: label & subLabel */}
            <Box sx={{ flexGrow: 1 }}>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 400,
                  fontFamily: 'Calibri',
                  fontSize: '1rem'
                }}
              >
                {option.label}
              </Typography>
              {option.subLabel && (
                <Typography
                  variant="caption"
                  sx={{
                    fontStyle: 'italic',
                    fontWeight: 400,
                    fontFamily: 'Calibri',
                    fontSize: '1rem'
                  }}
                >
                  {option.subLabel}
                </Typography>
              )}
            </Box>

            {/* Badge on the right (range or single value) */}
            <Box
              sx={{
                ml: 2,
                px: 1.5,
                py: 0.5,
                borderRadius: 3,
                border: '0.0625rem solid #1976D2', // blue border
                color: isSelected ? '#fff' : '#1976D2',
                backgroundColor: isSelected ? '#1976D2' : '#fff',
                fontSize: '0.875rem',
                fontWeight: 500,
                whiteSpace: 'nowrap'
              }}
            >
              {displayedValue}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
